import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faEye, faEyeSlash, faMobile } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../context/AuthContext';
import MobileAuthModal from '../MobileAuthModal';
import '../../styles/modals/AuthModal.css';

const AuthModal = ({ isOpen, onClose, onSuccess, title, subtitle }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);
  
  const { login } = useAuth();

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await login({ email, password });
      console.log('🔐 AuthModal: Login successful:', result);
      onSuccess && onSuccess(result);
    } catch (err) {
      console.error('🔐 AuthModal: Login error:', err);
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleMobileLogin = () => {
    setShowMobileModal(true);
  };

  const handleMobileLoginSuccess = (user) => {
    setShowMobileModal(false);
    onSuccess && onSuccess(user);
  };

  const handleMobileLoginCancel = () => {
    setShowMobileModal(false);
  };

  return (
    <>
      <div className="auth-modal-overlay" onClick={onClose}>
        <div className="auth-modal-content" onClick={(e) => e.stopPropagation()}>
          {/* Header */}
          <div className="auth-modal-header">
            <div className="auth-modal-header-text">
              <h2 className="auth-modal-title">{title || 'Welcome to Yesod'}</h2>
              {subtitle && <p className="auth-modal-subtitle">{subtitle}</p>}
            </div>
            <button className="auth-modal-close" onClick={onClose}>
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          {/* Logo */}
          <div className="auth-modal-logo">
            <img 
              src="https://xvhellooihpelwifxuik.supabase.co/storage/v1/object/public/assets//Yesodsybol%20(1).jpeg" 
              alt="Yesod" 
              className="modal-logo"
            />
          </div>

          {/* Error message */}
          {error && <div className="auth-modal-error">{error}</div>}

          {/* Login form */}
          <form onSubmit={handleSubmit} className="auth-modal-form">
            <div className="form-field">
              <input
                type="email"
                className="form-input"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            
            <div className="form-field password-field">
              <input
                type={showPassword ? "text" : "password"}
                className="form-input"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button
                type="button"
                className="password-toggle"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
              </button>
            </div>
            
            <button 
              type="submit" 
              className="auth-modal-button primary"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Continue'}
            </button>
          </form>

          {/* Divider */}
          <div className="auth-modal-divider">
            <span></span>
          </div>

          {/* Mobile login button */}
          <button 
            className="auth-modal-button mobile"
            onClick={handleMobileLogin}
            type="button"
          >
            <FontAwesomeIcon icon={faMobile} />
            Login with Phone Number
          </button>
        </div>
      </div>

      {/* Mobile Authentication Modal */}
      {showMobileModal && (
        <MobileAuthModal
          isOpen={true}
          onClose={handleMobileLoginCancel}
          onSuccess={handleMobileLoginSuccess}
          title="Mobile Login"
          subtitle="Enter your phone number to continue"
        />
      )}
    </>
  );
};

export default AuthModal;